<template>
  <div class="app-container">
    <el-card class="box-card">
      <el-form class="queryFormClass" label-position="top" size="small">
        <el-row :gutter="10">
          <el-col :span="6">
            <!-- 导出文件时间 -->
            <el-form-item :label="$t('basicData.exportStartTime')">
              <el-date-picker
                v-model="queryForm.params.importTimes"
                :default-time="['00:00:00', '23:59:59']"
                :end-placeholder="$t('GlobalSetObj.endDate')"
                :picker-options="pickerOptions"
                :start-placeholder="$t('GlobalSetObj.startDate')"
                style="width: 100%"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <!-- 模块 -->
            <el-form-item :label="$t('collectionCenter.module')">
              <el-select
                v-model="queryForm.params.modules"
                :placeholder="$t('basicData.pleaseSelectMultiple')"
                clearable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in MODULE"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 导出状态 -->
            <el-form-item :label="$t('basicData.exportStatus')">
              <el-select
                v-model="queryForm.params.statusList"
                :placeholder="$t('basicData.pleaseSelectMultiple')"
                clearable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in STATUS"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 导出人 -->
            <el-form-item :label="$t('basicData.exporter')">
              <QueryUserV2Cmp
                :multiple="true"
                :val="queryForm.params.createUserIds"
                style="width: 100%"
                @change="(val) => (queryForm.params.createUserIds = val)"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-row justify="start" type="flex">
        <el-col :span="4">
          <div>
            <!--查询-->
            <el-button
              icon="el-icon-search" size="mini" type="primary"
              @click="onSearch"
            >{{ $t('basicData.Search') }}
            </el-button>
            <!--重置-->
            <el-button icon="el-icon-refresh" size="mini" @click="onReset">{{ $t('basicData.reset') }}
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-card>
      <el-table
        ref="elTable"
        :data="tableData"
        :height="tableHeightRow.height"
        border
        class="table-height"
      >
        <!--序号-->
        <el-table-column :label="$t('basicData.serialNumber')" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('collectionCenter.module')" prop="module" width="120">
          <template slot-scope="scope">
            <span>{{ MODULE[scope.row.module] ? MODULE[scope.row.module].label : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('basicData.fileName')" min-width="180" prop="fileName" />
        <el-table-column :label="$t('basicData.dataVolume')" prop="totalCount" width="100" />
        <el-table-column :label="$t('basicData.exportStatus')" prop="status" width="120">
          <template slot-scope="scope">
            <el-tag :type="STATUS[scope.row.status] ? STATUS[scope.row.status].type : ''">
              {{ STATUS[scope.row.status] ? STATUS[scope.row.status].label : '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('basicData.progress')" prop="schedule" width="160">
          <template slot-scope="scope">
            <el-progress
              :percentage="scope.row.schedule"
              :status="
                scope.row.schedule === 100 || scope.row.status === 2
                  ? 'success'
                  : scope.row.status === 3
                    ? 'exception'
                    : 'warning'
              "
            />
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('collectionCenter.ReasonForFailure')"
          prop="failedMessage"
          width="140"
        />
        <el-table-column :label="$t('basicData.exporter')" prop="createUsername" width="140" />
        <el-table-column :label="$t('basicData.exportStartTime')" prop="startTime" width="160" />
        <el-table-column :label="$t('basicData.exportSuccessTime')" prop="endTime" width="160" />
        <el-table-column :label="$t('basicData.operate')" fixed="right" width="120">
          <template slot-scope="scope">
            <!-- 下载-->
            <el-button
              v-if="scope.row.status === 2"
              size="small"
              type="primary"
              @click="handleDownload(scope.row.fileUrl)"
            >{{ $t('GlobalSetObj.Download') }}
            </el-button>
            <!-- 重新导出-->
            <!--            <el-button-->
            <!--              v-if="[3,4].includes(scope.row.status)"-->
            <!--              size="small"-->
            <!--              type="warning"-->
            <!--            >{{-->
            <!--              $t('basicData.reExport')-->
            <!--            }}-->
            <!--            </el-button>-->
            <!-- 取消导出-->
            <el-popconfirm :title="$t('basicData.isCancel')" @confirm="cancelExport(scope.row.id)">
              <el-button
                v-if="!scope.row.status" slot="reference" size="small"
                type="info"
              >{{ $t('basicData.cancelExport') }}
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="asyncGetTableData"
          @size-change="asyncGetTableData"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { MODULE, STATUS } from './enums';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import QueryUserV2Cmp from '@/views/finance/cmp/Query/QueryUserV2Cmp.vue';
import {
  apiFaFinancialExportExcelCancel,
  apiFaFinancialExportExcelLogPage
} from '@/api/finance/fileExportManagement';
import { cloneDeep } from 'lodash-es';
import { setHttpTurnHttps } from '@/utils/tools';

const now = dayjs(); // 当前时间
// 获取一天前的日期
const startOfDay = dayjs().subtract(1, 'day').format('YYYY-MM-DD') + ' 00:00:00'; // 一天的开始
const endOfDay = now.endOf('day').format('YYYY-MM-DD HH:mm:ss'); // 一天的结束

const defaultQueryForm = {
  importTimes: [],
  statusList: [],
  modules: [],
  createUserIds: []
};

export default {
  name: 'FileExportManagement',

  components: {
    QueryUserV2Cmp
  },

  mixins: [estimateTableHeight],

  data() {
    return {
      MODULE,
      STATUS,
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          ...defaultQueryForm
        }
      },
      total: 0,
      tableData: [],
      interval: null,

      // 临时存储选择的开始日期的时间戳
      pickerMinDate: null,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          if (minDate) {
            this.pickerMinDate = minDate.getTime();
            this.$forceUpdate(); // 强制刷新组件状态
          } else {
            this.pickerMinDate = null;
          }
        },
        disabledDate: (time) => {
          if (!this.pickerMinDate) {
            return false;
          }

          // 计算限制范围 15天
          const selectedDate = dayjs(this.pickerMinDate);
          const minDate = selectedDate.subtract(15, 'day').startOf('day');
          const maxDate = selectedDate.add(15, 'day').endOf('day');

          return time.getTime() < minDate.valueOf() || time.getTime() > maxDate.valueOf();
        }
      }
    };
  },

  created() {
    // 初始化时间
    this.queryForm.params.importTimes = [startOfDay, endOfDay];
    this.asyncGetTableData();
  },

  mounted() {
    this.startClearTimer();
  },
  beforeDestroy() {
    // 清除定时器，防止内存泄漏
    this.endClearTimer();
  },
  activated() {
    this.startClearTimer();
  },
  deactivated() {
    this.endClearTimer();
  },

  methods: {
    // 统一启动定时器
    startClearTimer() {
      this.asyncGetTableData();
      // 组件被激活时重新创建定时器
      if (!this.interval) {
        this.interval = setInterval(() => {
          this.asyncGetTableData(false);
        }, 10 * 1000); // 10秒刷新一次
        console.log('定时器已重新创建');
      }
    },
    // 统一的定时器清除方法
    endClearTimer() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
        console.log('定时器已清除');
      }
    },

    // 搜索
    onSearch() {
      this.queryForm.pageNumber = 1;
      this.asyncGetTableData();
    },

    // 重置
    onReset() {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = 10;
      this.queryForm.params = {
        ...defaultQueryForm
      };
      this.queryForm.params.importTimes = [startOfDay, endOfDay];
    },

    // 参数初始化
    getQueryData() {
      const queryForm = cloneDeep(this.queryForm);
      const { importTimes, ...reset } = queryForm.params;
      queryForm.params = reset;

      // 时间处理
      if (!Array.isArray(importTimes)) {
        queryForm.params.startTimeBegin = '';
        queryForm.params.startTimeEnd = '';
      } else {
        queryForm.params.startTimeBegin = importTimes[0];
        queryForm.params.startTimeEnd = importTimes[1];
      }
      console.log('queryForm', queryForm);
      return queryForm;
    },

    // 获取列表
    asyncGetTableData(bool) {
      const params = this.getQueryData();
      apiFaFinancialExportExcelLogPage(params, bool)
        .then((res) => {
          if (res.code === 200) {
            const { total, records } = res.data;
            this.total = total;
            this.tableData = records.map((item) => {
              // 计算进度条
              let schedule = 0;

              // 优先判断：存在下载链接表示导出完成
              if (item.fileUrl) {
                schedule = 100;
                item.status = 2; // 成功状态
              } else if (item.successCount === 0 && item.totalCount === 0 && item.status === 2) {
                // 特殊情况：计数都为0且状态为成功
                schedule = 100;
              } else if (item.totalCount > 0) {
                // 正常计算进度：基于成功数/总数
                const progress = (item.successCount / item.totalCount) * 100;
                schedule = progress > 100 ? 100 : Number(progress.toFixed(1));
              }

              item.schedule = schedule;

              return {
                ...item
              };
            });
            console.log('tableData', this.tableData);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    /**
     * 文件下载
     */
    handleDownload(url) {
      console.log('url', url);
      if (url === 'ok') {
        this.$message({
          // '导入成功无错误数据'
          message: this.$t('Resource.importSuccessNotErr'),
          type: 'warning'
        });
        return;
      }
      if (url.length) {
        const a = document.createElement('a');
        a.href = setHttpTurnHttps(url);
        a.click();
      }
    },

    // 取消导出
    cancelExport(id) {
      apiFaFinancialExportExcelCancel(id)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: this.$t('basicData.TheOperationSucceeded'),
              type: 'success'
            });
            this.asyncGetTableData();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.box-card {
  margin-bottom: 10px;
}
</style>
